<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <div class="d-flex content-action align-items-center">
                <div class="input-group border-bottom position-relative" style="width: 190px">
                    <input class="form-control bg-transparent border-none pr-4" :placeholder="$t('common.search')"
                        aria-label="Search" v-model="searchKeyword" style="min-width: 190px" />
                    <i class="fa fa-search position-absolute" style="top: 50%; right: 4px; margin-top: -6px" />
                </div>
                <div class="mx-3 font-20">|</div>
                <div class="d-flex align-items-center text-nowrap">
                    <b-button variant="outline-primary" @click="openCreateModal">
                        <i class="fa fa-plus-circle mr-2"></i>
                        <span class="text-uppercase">{{ $t('user.createUser') }}</span>
                    </b-button>
                </div>
            </div>
            <b-table class="mt-2" striped hover :items="listUsers" :fields="fields" show-empty :filter="searchKeyword"
                :filter-included-fields="['name']">
                <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
                <template v-slot:cell(createdAt)="data">
                    <span>{{ data.value | formatDateTime }}</span>
                </template>
                <template v-slot:cell(actions)="row">
                    <b-button variant="primary" class="mr-1 min-width-none" @click="openEditModal(row.item)"
                        v-b-tooltip.hover :title="$t('common.edit')">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button variant="danger" @click="confirmDelete(row.item)" v-b-tooltip.hover class="min-width-none"
                        :title="$t('common.delete')">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
                <template v-slot:empty>
                    <div class="text-center">
                        <span>{{ $t('user.empty') }}</span>
                    </div>
                </template>
            </b-table>
        </div>

        <b-modal ref="createOrUpdateUserModal" :title="`${form.id ? $t('common.update') : $t('common.create')}`"
            ok-title="Lưu" @ok="handleCreateUserOk" :cancel-title="$t('common.cancel')">
            <b-form-group :label="$t('user.fullName')">
                <b-form-input maxlength="255" v-model="form.name" v-validate="'required'"
                    :placeholder="$t('user.fullName')" name="name" :data-vv-as="$t('user.fullName')"></b-form-input>
                <div v-show="errors.has('name')" class="validation-message text-danger">
                    {{ errors.first('name') }}
                </div>
            </b-form-group>
            <b-form-group label="Tên đăng nhập:">
                <b-form-input v-model="form.username" type="username" v-validate="'required'"
                    placeholder="Tên đăng nhập" name="username" autocomplete="off" data-vv-as="Tên đăng nhập"
                    :disabled="form.id != null"></b-form-input>
                <div v-show="errors.has('username')" class="validation-message text-danger">
                    {{ errors.first('username') }}
                </div>
            </b-form-group>
            <b-form-group :label="$t('user.password')">
                <b-form-input v-model="form.password" type="password" v-validate="form.id != null ? '' : 'required'"
                    autocomplete="off" :placeholder="$t('user.password')" name="password"
                    data-vv-as="Mật khẩu"></b-form-input>
                <div v-show="errors.has('password')" class="validation-message text-danger">
                    {{ errors.first('password') }}
                </div>
            </b-form-group>
            <b-form-group :label="$t('user.group')">
                <b-form-select v-model="form.groupId" v-validate="'required'" name="group"
                    :data-vv-as="$t('user.group')" @change="onChangeGroup">
                    <option :value="null">{{ $t('user.chooseGroup') }}</option>
                    <option v-for="group in listGroups" :value="group.id">{{ group.name }}</option>
                </b-form-select>
                <div v-show="errors.has('group')" class="validation-message text-danger">
                    {{ errors.first('group') }}
                </div>
            </b-form-group>
            <b-form-group :label="$t('user.permission')">
                <b-form-checkbox-group v-model="form.functions">
                    <b-form-checkbox v-for="(func, index) in listFunctions" :key="index" :value="func" class="mr-3"
                        :disabled="func === 'system'">{{ permissionNameRender(func) }}</b-form-checkbox>
                </b-form-checkbox-group>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
    async mounted() {
        await this.$nextTick();
        await this.getListGroups();
        await this.getListUsers();
        await this.getAllFunctions();
    },
    data: function () {
        return {
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'name',
                    label: this.$i18n.t('user.fullName')
                },
                { tdClass: 'align-middle', key: 'username', label: 'Tên đăng nhập' },
                {
                    tdClass: 'align-middle',
                    key: 'createdAt',
                    label: this.$i18n.t('common.lastCreated')
                },
                {
                    thClass: 'fixed-actions-col',
                    key: 'actions',
                    label: this.$i18n.t('common.actions'),
                    thStyle: { width: '100px' }
                }
            ],
            form: {
                username: '',
                name: '',
                password: null,
                functions: [],
                groupId: null
            },
            searchKeyword: null
        };
    },
    computed: {
        ...mapState({
            listGroups: state => state.group.groups,
            listUsers: state => state.user.users,
            listFunctions: state => state.user.functions
        }),
        groupName() {
            const group = {};
            this.listGroups.forEach(element => {
                group[element.id] = element.name;
            });
            return group;
        }
    },
    methods: {
        ...mapActions({
            getListGroups: 'group/getListGroups',
            getListUsers: 'user/getListUsers',
            createNewUser: 'user/createNewUser',
            deleteUserById: 'user/deleteUserById',
            updateUserInfo: 'user/updateUserInfo',
            getAllFunctions: 'user/getAllFunctions',
            createAuditByUser: 'user/createAuditByUser'
        }),
        handleCreateUserOk(modal) {
            modal.preventDefault();
            this.onSubmit();
        },
        onSubmit() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.submitForm();
                }
            });
        },
        async onDeleteUser(modal) {
            modal.preventDefault();
        },
        async openEditModal(user) {
            this.resetForm();
            this.form = { ...user };
            this.form.password = null;
            this.$refs.createOrUpdateUserModal.show();
        },
        openCreateModal() {
            this.resetForm();
            this.$refs.createOrUpdateUserModal.show();
        },
        async confirmDelete(user) {
            const result = await this.$bvModal.msgBoxConfirm(
                'Bạn có chắc chắn muốn xoá người dùng này?',
                {
                    title: 'Xác nhận',
                    okVariant: 'danger',
                    okTitle: 'Có',
                    cancelTitle: 'Không'
                }
            );
            if (result) {
                await this.deleteUserById({ id: user.id });
                await this.getListUsers();
                this.$toaster.success(this.$i18n.t('user.deleteUserMess'));
                this.createAuditByUser({ content: 'Xoá người dùng' });
            }
        },
        resetForm() {
            this.form = {};
        },
        async submitForm() {
            if (this.form.id) {
                await this.updateUserInfo(this.form);
            } else {
                await this.createNewUser(this.form);
            }
            this.$toaster.success(
                `${this.form.id ? this.$i18n.t('common.update') : this.$i18n.t('common.create')
                } ${this.$i18n.t('user.userSuccess')}`
            );
            this.createAuditByUser({ content: `${this.form.id ? 'Cập nhật' : 'Tạo'} người dùng` });
            this.getListUsers();
            this.$refs.createOrUpdateUserModal.hide();
        },
        permissionNameRender(func) {
            switch (func) {
                case 'system':
                    return 'Hệ thống';
                case 'database':
                    return 'Cơ sở dữ liệu';
                case 'news':
                    return 'Tin tức';
                case 'user':
                    return 'Người dùng';
                case 'data-layer':
                    return 'Lớp dữ liệu';
            }
        },
        onChangeGroup(groupId) {
            const group = this.listGroups.find(item => item.id === groupId);
            if (group) this.form.functions = group.functions;
        }
    }
};
</script>
